module.exports = __webpack_public_path__ + "img/RM3.dd7527bf.jpeg";